import {
  Card,
  FlatActionList,
  FlatActionListItem,
  Page,
  Stack,
} from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { CheckoutSummaryMoreActionsRootParamList } from "../../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { usePrintDocket } from "../../../../utilities/docket";
import { useCheckoutContextProvider } from "../../utils/checkout";
import { useDatabase } from "@nozbe/watermelondb/react";
import DocketTemplate from "../../../../utilities/data/model/DocketTemplate";
import React from "react";

export type CheckoutSummaryMoreActionsRootScreenProps = NativeStackScreenProps<
  any & CheckoutSummaryMoreActionsRootParamList,
  "CheckoutSummaryMoreActionsScreen"
>;
export const CheckoutSummaryMoreActionsScreen = ({
  navigation,
}: CheckoutSummaryMoreActionsRootScreenProps) => {
  const [printingDocket, setPrintingDocket] = React.useState(false);

  const { t } = useTranslation("pos");
  const { sale } = useCheckoutContextProvider();
  const database = useDatabase();

  const { handleOnPrintAllDockets } = usePrintDocket();

  const actions: FlatActionListItem[] = [];

  const handleOnPrintDocket = React.useCallback(async () => {
    setPrintingDocket(true);
    try {
      await handleOnPrintAllDockets(sale);
    } catch (error) {
      console.error(error);
    }

    setPrintingDocket(false);
  }, []);
  actions.push({
    key: "edit_purchase_order_number",
    title: t("action.edit_purchase_order_number.label"),
    subTitle: t("action.edit_purchase_order_number.description"),
    disabled: false,
    onPress: () => {
      navigation.navigate("EditPurchaseOrderNumberScreen");
    },
  });

  actions.push({
    key: "print_docket",
    title: t("action.print_docket.label"),
    subTitle: t("action.print_docket.description"),
    disabled: false,
    onPress: handleOnPrintDocket,
  });

  return (
    <Page>
      <Stack vertical>
        <Card>
          <FlatActionList items={actions} />
        </Card>
      </Stack>
    </Page>
  );
};
